import { render, staticRenderFns } from "./BaseGallery.vue?vue&type=template&id=4fb29002&scoped=true&"
import script from "./BaseGallery.vue?vue&type=script&lang=js&"
export * from "./BaseGallery.vue?vue&type=script&lang=js&"
import style0 from "./BaseGallery.vue?vue&type=style&index=0&id=4fb29002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb29002",
  null
  
)

export default component.exports